import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as contentActions from '../content/content.actions';

import { ContentSection } from './components';
import Article from '../content/components/Article';

class RulesPreviewPage extends Component {
  componentWillMount = () => {
    const { getContents } = this.props;
    getContents();
  }

  render() {
    const {
      singleContent,
    } = this.props;
    if(!singleContent) return null;
    
    return (
      <ContentSection>
        <Article
          title={singleContent.name}
          content={singleContent.content}
        />
      </ContentSection>
    );
  }
};

const mapStateToProps = (state, { match }) => {
  const { id } = match.params;
  const singleContent = id ? state.entities.content.byId[id] : null;
  return {
    singleContent,
  };
};

const ConnectedRulesPreviewPage = connect(
  mapStateToProps,
  Object.assign({}, contentActions),
)(RulesPreviewPage);

export default withRouter(ConnectedRulesPreviewPage);


// WEBPACK FOOTER //
// ./src/modules/pages/RulesPreviewPage.js